import React from 'react';
import { ContentArea } from '../../base/container/container';
import VerticalTimeline from '../../base/verticalTimeline/verticalTimeline';
import './events.css';

const timelineData = [
  {
    title: '@Fusion, Lärz: June 27, 2018',
    body: 'Lineup: Änne-Marthe Kühn, David Ford, Martin Klaus, Ruben Giannotti',
    background: 'http://pornoundpiano.de/assets/media/img/thumbnails/pp_events_bg-006.jpg',
    link: { anchor: 'More information', destination: 'https://www.fusion-festival.de/2018/programm/performance/' }
  },
  {
    title: '@Kunstkooperative Berlin: May, 19 2018',
    body: 'Lineup: Änne-Marthe Kühn, Thea Dymke, David Ford, Martin Klaus, Ruben Giannotti',
    background: 'http://pornoundpiano.de/assets/media/img/thumbnails/pp_events_bg-005.jpg',
    link: { anchor: 'More information', destination: 'https://www.kunstkooperative.com/' }
  },
  {
    title: '@Tatwerk Performative Forschung, Berlin: March 18, 2018',
    body: 'Lineup: Änne-Marthe Kühn, Thea Dymke, David Ford, Martin Klaus, Ruben Giannotti',
    background: 'http://pornoundpiano.de/assets/media/img/thumbnails/pp_events_bg-004.jpg',
    link: { anchor: 'More information', destination: 'https://www.tatwerk-berlin.de/en/programm/events/338-porno-und-piano?date=2018-03-17-20-30' }
  },
  {
    title: '@Greenhouse, Berlin: November, 20 2017',
    body: 'Lineup: Änne-Marthe Kühn, Thea Dymke, Thomas Eder, David Ford, Ruben Giannotti',
    background: 'http://pornoundpiano.de/assets/media/img/thumbnails/pp_events_bg-003.jpg',
    link: { anchor: 'More information', destination: 'http://gh.greenhouse-berlin.de/index.php' }
  },
  {
    title: '@Herman Schulz, Berlin: August, 8 2016',
    body: 'Lineup: Änne-Marthe Kühn, Thea Dymke, Thomas Eder, David Ford, Ruben Giannotti',
    background: 'http://pornoundpiano.de/assets/media/img/thumbnails/pp_events_bg-002.jpg',
    link: { anchor: 'More information', destination: 'https://www.meetup.com/en-AU/shminternationals/events/232305627/' }
  },
  {
    title: '@kaufbar, Berlin: May, 18 2016',
    body: 'Lineup: Änne-Marthe Kühn, Thea Dymke, Thomas Eder, David Ford',
    background: 'http://pornoundpiano.de/assets/media/img/thumbnails/pp_events_bg-001.jpg'
  }
];

const Photos = () => {
  return(
    <ContentArea>
      <section className="events-section" id="events">
        <h2>Past events</h2>
        <VerticalTimeline data={timelineData} />
      </section>
    </ContentArea>
  );
}

export default Photos;
